import {
  MAX_CONTACT_ENTRIES,
  createEmptyContactEntry,
  defaultContactEntryLabel,
  formatContactEntrySummary,
  normalizeContactEntries,
  primaryContactEntry,
  primaryContactEntryValue,
  resolveContactEntriesFromData,
  contactEntryKey,
} from './contactEntries';

export const MAX_CONTACT_PHONES = MAX_CONTACT_ENTRIES;

function phoneDedupeKey(value) {
  return String(value || '').trim().replace(/[\s-]/g, '');
}

export function normalizeContactPhones(values) {
  return normalizeContactEntries(values, phoneDedupeKey);
}

export function resolveContactPhonesFromData(data = {}) {
  return resolveContactEntriesFromData(data, {
    arrayField: 'phones',
    legacyField: 'phone',
    dedupeKeyForValue: phoneDedupeKey,
  });
}

export function primaryContactPhone(phones = []) {
  return primaryContactEntryValue(phones);
}

export function formatContactPhonesSummary(phones = []) {
  return formatContactEntrySummary(phones);
}

export { createEmptyContactEntry, defaultContactEntryLabel, primaryContactEntry, contactEntryKey };
